import OperatorService from "@/api/services/operator.service";

const IntercomsService = {
  getList(params = { search: "", page: 1, count: 10, id_camera: "" }) {
    return OperatorService.get(`/intercoms`, { headers: params });
  },

  get(id) {
    return OperatorService.get(`/intercoms/${id}`);
  },

  delete(id) {
    return OperatorService.delete(`/intercoms/${id}`);
  },

  update(id, newIntercom) {
    return OperatorService.put(`/intercoms/${id}`, newIntercom);
  },

  create(newIntercom) {
    return OperatorService.post(`/intercoms`, newIntercom);
  },
};

export default IntercomsService;
